// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "category.proto" (package "category", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message category.Category
 */
export interface Category {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: uint32 parent_id = 3
     */
    parentId: number;
    /**
     * @generated from protobuf field: string icon_name = 4
     */
    iconName: string;
    /**
     * @generated from protobuf field: string icon_color = 5
     */
    iconColor: string;
    /**
     * @generated from protobuf field: string icon_background = 6
     */
    iconBackground: string;
    /**
     * @generated from protobuf field: bool fixed_costs = 7
     */
    fixedCosts: boolean;
    /**
     * @generated from protobuf field: double ordering = 8
     */
    ordering: number;
}
/**
 * @generated from protobuf message category.GetAllCategoriesRequest
 */
export interface GetAllCategoriesRequest {
}
/**
 * @generated from protobuf message category.GetAllCategoriesResponse
 */
export interface GetAllCategoriesResponse {
    /**
     * @generated from protobuf field: repeated category.Category categories = 1
     */
    categories: Category[];
}
/**
 * @generated from protobuf message category.CreateCategoryRequest
 */
export interface CreateCategoryRequest {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: uint32 parent_id = 2
     */
    parentId: number;
    /**
     * @generated from protobuf field: string icon_name = 3
     */
    iconName: string;
    /**
     * @generated from protobuf field: string icon_color = 4
     */
    iconColor: string;
    /**
     * @generated from protobuf field: string icon_background = 5
     */
    iconBackground: string;
    /**
     * @generated from protobuf field: bool fixed_costs = 6
     */
    fixedCosts: boolean;
    /**
     * @generated from protobuf field: double ordering = 8
     */
    ordering: number;
}
/**
 * @generated from protobuf message category.CreateCategoryResponse
 */
export interface CreateCategoryResponse {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
}
/**
 * @generated from protobuf message category.UpdateCategoryFields
 */
export interface UpdateCategoryFields {
    /**
     * @generated from protobuf field: optional string name = 1
     */
    name?: string;
    /**
     * @generated from protobuf field: bool update_parent_id = 2
     */
    updateParentId: boolean;
    /**
     * @generated from protobuf field: optional uint32 parent_id = 3
     */
    parentId?: number;
    /**
     * @generated from protobuf field: optional string icon_name = 4
     */
    iconName?: string;
    /**
     * @generated from protobuf field: optional string icon_color = 5
     */
    iconColor?: string;
    /**
     * @generated from protobuf field: optional string icon_background = 6
     */
    iconBackground?: string;
    /**
     * @generated from protobuf field: optional bool fixed_costs = 7
     */
    fixedCosts?: boolean;
    /**
     * @generated from protobuf field: optional double ordering = 8
     */
    ordering?: number;
}
/**
 * @generated from protobuf message category.UpdateCategoryRequest
 */
export interface UpdateCategoryRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: category.UpdateCategoryFields fields = 2
     */
    fields?: UpdateCategoryFields;
}
/**
 * @generated from protobuf message category.UpdateCategoryResponse
 */
export interface UpdateCategoryResponse {
}
/**
 * @generated from protobuf message category.DeleteCategoryRequest
 */
export interface DeleteCategoryRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: optional uint32 target_id = 2
     */
    targetId?: number;
    /**
     * @generated from protobuf field: bool delete_transactions = 3
     */
    deleteTransactions: boolean;
}
/**
 * @generated from protobuf message category.DeleteCategoryResponse
 */
export interface DeleteCategoryResponse {
    /**
     * @generated from protobuf field: uint32 moved_transactions = 1
     */
    movedTransactions: number;
    /**
     * @generated from protobuf field: uint32 moved_categories = 2
     */
    movedCategories: number;
    /**
     * @generated from protobuf field: uint32 deleted_transactions = 3
     */
    deletedTransactions: number;
    /**
     * @generated from protobuf field: uint32 moved_to_unconfirmed = 4
     */
    movedToUnconfirmed: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class Category$Type extends MessageType<Category> {
    constructor() {
        super("category.Category", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "parent_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "icon_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "icon_color", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "icon_background", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "fixed_costs", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "ordering", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<Category>): Category {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.name = "";
        message.parentId = 0;
        message.iconName = "";
        message.iconColor = "";
        message.iconBackground = "";
        message.fixedCosts = false;
        message.ordering = 0;
        if (value !== undefined)
            reflectionMergePartial<Category>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Category): Category {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* uint32 parent_id */ 3:
                    message.parentId = reader.uint32();
                    break;
                case /* string icon_name */ 4:
                    message.iconName = reader.string();
                    break;
                case /* string icon_color */ 5:
                    message.iconColor = reader.string();
                    break;
                case /* string icon_background */ 6:
                    message.iconBackground = reader.string();
                    break;
                case /* bool fixed_costs */ 7:
                    message.fixedCosts = reader.bool();
                    break;
                case /* double ordering */ 8:
                    message.ordering = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Category, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* uint32 parent_id = 3; */
        if (message.parentId !== 0)
            writer.tag(3, WireType.Varint).uint32(message.parentId);
        /* string icon_name = 4; */
        if (message.iconName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.iconName);
        /* string icon_color = 5; */
        if (message.iconColor !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.iconColor);
        /* string icon_background = 6; */
        if (message.iconBackground !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.iconBackground);
        /* bool fixed_costs = 7; */
        if (message.fixedCosts !== false)
            writer.tag(7, WireType.Varint).bool(message.fixedCosts);
        /* double ordering = 8; */
        if (message.ordering !== 0)
            writer.tag(8, WireType.Bit64).double(message.ordering);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message category.Category
 */
export const Category = new Category$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllCategoriesRequest$Type extends MessageType<GetAllCategoriesRequest> {
    constructor() {
        super("category.GetAllCategoriesRequest", []);
    }
    create(value?: PartialMessage<GetAllCategoriesRequest>): GetAllCategoriesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAllCategoriesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllCategoriesRequest): GetAllCategoriesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllCategoriesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message category.GetAllCategoriesRequest
 */
export const GetAllCategoriesRequest = new GetAllCategoriesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllCategoriesResponse$Type extends MessageType<GetAllCategoriesResponse> {
    constructor() {
        super("category.GetAllCategoriesResponse", [
            { no: 1, name: "categories", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Category }
        ]);
    }
    create(value?: PartialMessage<GetAllCategoriesResponse>): GetAllCategoriesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.categories = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllCategoriesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllCategoriesResponse): GetAllCategoriesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated category.Category categories */ 1:
                    message.categories.push(Category.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllCategoriesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated category.Category categories = 1; */
        for (let i = 0; i < message.categories.length; i++)
            Category.internalBinaryWrite(message.categories[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message category.GetAllCategoriesResponse
 */
export const GetAllCategoriesResponse = new GetAllCategoriesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCategoryRequest$Type extends MessageType<CreateCategoryRequest> {
    constructor() {
        super("category.CreateCategoryRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "parent_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "icon_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "icon_color", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "icon_background", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "fixed_costs", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "ordering", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<CreateCategoryRequest>): CreateCategoryRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.parentId = 0;
        message.iconName = "";
        message.iconColor = "";
        message.iconBackground = "";
        message.fixedCosts = false;
        message.ordering = 0;
        if (value !== undefined)
            reflectionMergePartial<CreateCategoryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateCategoryRequest): CreateCategoryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* uint32 parent_id */ 2:
                    message.parentId = reader.uint32();
                    break;
                case /* string icon_name */ 3:
                    message.iconName = reader.string();
                    break;
                case /* string icon_color */ 4:
                    message.iconColor = reader.string();
                    break;
                case /* string icon_background */ 5:
                    message.iconBackground = reader.string();
                    break;
                case /* bool fixed_costs */ 6:
                    message.fixedCosts = reader.bool();
                    break;
                case /* double ordering */ 8:
                    message.ordering = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateCategoryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* uint32 parent_id = 2; */
        if (message.parentId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.parentId);
        /* string icon_name = 3; */
        if (message.iconName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.iconName);
        /* string icon_color = 4; */
        if (message.iconColor !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.iconColor);
        /* string icon_background = 5; */
        if (message.iconBackground !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.iconBackground);
        /* bool fixed_costs = 6; */
        if (message.fixedCosts !== false)
            writer.tag(6, WireType.Varint).bool(message.fixedCosts);
        /* double ordering = 8; */
        if (message.ordering !== 0)
            writer.tag(8, WireType.Bit64).double(message.ordering);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message category.CreateCategoryRequest
 */
export const CreateCategoryRequest = new CreateCategoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCategoryResponse$Type extends MessageType<CreateCategoryResponse> {
    constructor() {
        super("category.CreateCategoryResponse", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<CreateCategoryResponse>): CreateCategoryResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<CreateCategoryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateCategoryResponse): CreateCategoryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateCategoryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message category.CreateCategoryResponse
 */
export const CreateCategoryResponse = new CreateCategoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCategoryFields$Type extends MessageType<UpdateCategoryFields> {
    constructor() {
        super("category.UpdateCategoryFields", [
            { no: 1, name: "name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "update_parent_id", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "parent_id", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "icon_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "icon_color", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "icon_background", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "fixed_costs", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "ordering", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCategoryFields>): UpdateCategoryFields {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.updateParentId = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateCategoryFields>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCategoryFields): UpdateCategoryFields {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string name */ 1:
                    message.name = reader.string();
                    break;
                case /* bool update_parent_id */ 2:
                    message.updateParentId = reader.bool();
                    break;
                case /* optional uint32 parent_id */ 3:
                    message.parentId = reader.uint32();
                    break;
                case /* optional string icon_name */ 4:
                    message.iconName = reader.string();
                    break;
                case /* optional string icon_color */ 5:
                    message.iconColor = reader.string();
                    break;
                case /* optional string icon_background */ 6:
                    message.iconBackground = reader.string();
                    break;
                case /* optional bool fixed_costs */ 7:
                    message.fixedCosts = reader.bool();
                    break;
                case /* optional double ordering */ 8:
                    message.ordering = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCategoryFields, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string name = 1; */
        if (message.name !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* bool update_parent_id = 2; */
        if (message.updateParentId !== false)
            writer.tag(2, WireType.Varint).bool(message.updateParentId);
        /* optional uint32 parent_id = 3; */
        if (message.parentId !== undefined)
            writer.tag(3, WireType.Varint).uint32(message.parentId);
        /* optional string icon_name = 4; */
        if (message.iconName !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.iconName);
        /* optional string icon_color = 5; */
        if (message.iconColor !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.iconColor);
        /* optional string icon_background = 6; */
        if (message.iconBackground !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.iconBackground);
        /* optional bool fixed_costs = 7; */
        if (message.fixedCosts !== undefined)
            writer.tag(7, WireType.Varint).bool(message.fixedCosts);
        /* optional double ordering = 8; */
        if (message.ordering !== undefined)
            writer.tag(8, WireType.Bit64).double(message.ordering);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message category.UpdateCategoryFields
 */
export const UpdateCategoryFields = new UpdateCategoryFields$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCategoryRequest$Type extends MessageType<UpdateCategoryRequest> {
    constructor() {
        super("category.UpdateCategoryRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "fields", kind: "message", T: () => UpdateCategoryFields }
        ]);
    }
    create(value?: PartialMessage<UpdateCategoryRequest>): UpdateCategoryRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateCategoryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCategoryRequest): UpdateCategoryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* category.UpdateCategoryFields fields */ 2:
                    message.fields = UpdateCategoryFields.internalBinaryRead(reader, reader.uint32(), options, message.fields);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCategoryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* category.UpdateCategoryFields fields = 2; */
        if (message.fields)
            UpdateCategoryFields.internalBinaryWrite(message.fields, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message category.UpdateCategoryRequest
 */
export const UpdateCategoryRequest = new UpdateCategoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCategoryResponse$Type extends MessageType<UpdateCategoryResponse> {
    constructor() {
        super("category.UpdateCategoryResponse", []);
    }
    create(value?: PartialMessage<UpdateCategoryResponse>): UpdateCategoryResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCategoryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCategoryResponse): UpdateCategoryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCategoryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message category.UpdateCategoryResponse
 */
export const UpdateCategoryResponse = new UpdateCategoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCategoryRequest$Type extends MessageType<DeleteCategoryRequest> {
    constructor() {
        super("category.DeleteCategoryRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "target_id", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "delete_transactions", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteCategoryRequest>): DeleteCategoryRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.deleteTransactions = false;
        if (value !== undefined)
            reflectionMergePartial<DeleteCategoryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteCategoryRequest): DeleteCategoryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* optional uint32 target_id */ 2:
                    message.targetId = reader.uint32();
                    break;
                case /* bool delete_transactions */ 3:
                    message.deleteTransactions = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteCategoryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* optional uint32 target_id = 2; */
        if (message.targetId !== undefined)
            writer.tag(2, WireType.Varint).uint32(message.targetId);
        /* bool delete_transactions = 3; */
        if (message.deleteTransactions !== false)
            writer.tag(3, WireType.Varint).bool(message.deleteTransactions);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message category.DeleteCategoryRequest
 */
export const DeleteCategoryRequest = new DeleteCategoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCategoryResponse$Type extends MessageType<DeleteCategoryResponse> {
    constructor() {
        super("category.DeleteCategoryResponse", [
            { no: 1, name: "moved_transactions", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "moved_categories", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "deleted_transactions", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "moved_to_unconfirmed", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteCategoryResponse>): DeleteCategoryResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.movedTransactions = 0;
        message.movedCategories = 0;
        message.deletedTransactions = 0;
        message.movedToUnconfirmed = 0;
        if (value !== undefined)
            reflectionMergePartial<DeleteCategoryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteCategoryResponse): DeleteCategoryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 moved_transactions */ 1:
                    message.movedTransactions = reader.uint32();
                    break;
                case /* uint32 moved_categories */ 2:
                    message.movedCategories = reader.uint32();
                    break;
                case /* uint32 deleted_transactions */ 3:
                    message.deletedTransactions = reader.uint32();
                    break;
                case /* uint32 moved_to_unconfirmed */ 4:
                    message.movedToUnconfirmed = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteCategoryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 moved_transactions = 1; */
        if (message.movedTransactions !== 0)
            writer.tag(1, WireType.Varint).uint32(message.movedTransactions);
        /* uint32 moved_categories = 2; */
        if (message.movedCategories !== 0)
            writer.tag(2, WireType.Varint).uint32(message.movedCategories);
        /* uint32 deleted_transactions = 3; */
        if (message.deletedTransactions !== 0)
            writer.tag(3, WireType.Varint).uint32(message.deletedTransactions);
        /* uint32 moved_to_unconfirmed = 4; */
        if (message.movedToUnconfirmed !== 0)
            writer.tag(4, WireType.Varint).uint32(message.movedToUnconfirmed);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message category.DeleteCategoryResponse
 */
export const DeleteCategoryResponse = new DeleteCategoryResponse$Type();
/**
 * @generated ServiceType for protobuf service category.CategoryService
 */
export const CategoryService = new ServiceType("category.CategoryService", [
    { name: "GetAllCategories", options: {}, I: GetAllCategoriesRequest, O: GetAllCategoriesResponse },
    { name: "CreateCategory", options: {}, I: CreateCategoryRequest, O: CreateCategoryResponse },
    { name: "UpdateCategory", options: {}, I: UpdateCategoryRequest, O: UpdateCategoryResponse },
    { name: "DeleteCategory", options: {}, I: DeleteCategoryRequest, O: DeleteCategoryResponse }
]);
